module.exports = __webpack_public_path__ + "static/RUmobSlide2-a8cc6993e340596d36b7855f9cf97cf3.jpg";